import PageChange from './PageChange.hoc';

export default PageChange;